<div class="h-100">
  <mat-drawer-container class="sidenav-container mat-typography">
    <mat-drawer #drawer
              mode="side"
              [disableClose]="true"
              opened="true"
              [class.sidenav-collapsed]="!isOpen && !shouldPinSidenav">
      <mat-nav-list class="sidenav-menu-list">
        @if (variables && variables.controlPanel) {
        <mat-list-item *hasPermission="Permission.ESTIMATE_ACCESS_SCREEN" routerLink="/dashboard" class="sidenav-menu-list-item">
        <!--mat-list-item *hasPermission="Permission.ESTIMATE_ACCESS_SCREEN" 
                        routerLink="/dashboard" class="sidenav-menu-list-item"-->
          <div class="item-container">
            <mat-icon svgIcon="House" style="width:25px; height:25px;"></mat-icon>
            <h4 [routerLinkActive]="['is-active']" class="menu-item" mat-line>{{
              variables.controlPanel }}</h4>
          </div>
        </mat-list-item>
        }
        @if (variables && variables.myProjects) {
        <mat-list-item *hasPermission="Permission.PROJECT_ACCESS_SCREEN" (click)="navigateToProjects()" class="sidenav-menu-list-item">
          <div class="item-container">
            <mat-icon svgIcon="Folder" style="width:25px; height:25px;"></mat-icon>
            <h4 [routerLinkActive]="['is-active']" class="menu-item" mat-line>{{
              variables.myProjects }}</h4>
          </div>
        </mat-list-item>
        }

        <!--@if (variables && variables.notifications) {
        <mat-list-item routerLink="/notifications" class="sidenav-menu-list-item">
          <div class="item-container">
            <mat-icon svgIcon="Notification" style="width:25px; height:25px;"></mat-icon>
            <h4 [routerLinkActive]="['is-active']" class="menu-item" mat-line>{{
              variables.notifications }}</h4>
          </div>
        </mat-list-item>
        }-->

        @if (variables && variables.backoffice) {
        <mat-list-item (click)="actionDivCatalogs(openDivCatalogs)" class="sidenav-menu-list-item">
          <div class="item-container">
            <mat-icon svgIcon="BackOffice" style="width:25px; height:25px;margin-top: -15px;"></mat-icon>
            <h4 class="menu-item" mat-line>{{ variables.backoffice }}
              @if (!openDivCatalogs) {
              <mat-icon class="trans-span" style="margin: 0;">arrow_drop_down</mat-icon>
              }
              @if (openDivCatalogs) {
              <mat-icon class="trans-span" style="margin: 0;">arrow_drop_up</mat-icon>
              }
            </h4>
          </div>
        </mat-list-item>
        }

        @if (openDivCatalogs) {
        <div @slideToggle class="sidenav-item-list-wrapper">
          @if (variables && variables.genericCatalog) {
          <mat-list-item *hasPermission="Permission.CATALOG_ACCESS_SCREEN" style="width: 90%" [routerLink]="['/management']" [queryParams]="{ id: 'generic' }"
            class="sidenav-menu-list-item mat-list-new-div">
          <!--mat-list-item *hasPermission="Permission.CATALOG_ACCESS_SCREEN" style="width: 90%" [routerLink]="['/management']" [queryParams]="{ id: 'generic' }"
            class="sidenav-menu-list-item mat-list-new-div"-->
            <h4 [routerLinkActive]="['is-active']" mat-line>
              {{variables.genericCatalog}}</h4>
          </mat-list-item>
          }
          @if (variables) {
          <mat-list-item style="width: 90%" routerLink="/catalog-stats"
            class="sidenav-menu-list-item mat-list-new-div">
            <h4 [routerLinkActive]="['is-active']" mat-line>
              {{variables.catalogStats || 'Estadísticas catálogo'}}</h4>
          </mat-list-item>
          }
          @if (variables && variables.profiles) {
          <mat-list-item *hasPermission="Permission.PROFILE_ACCESS_SCREEN" style="width: 90%" routerLink="/perfiles" class="sidenav-menu-list-item mat-list-new-div">
          <!--mat-list-item *hasPermission="Permission.PROFILE_ACCESS_SCREEN" style="width: 90%" routerLink="/perfiles" class="sidenav-menu-list-item mat-list-new-div"-->
            <h4 [routerLinkActive]="['is-active']" mat-line>
              {{variables.profiles}}</h4>
          </mat-list-item>
          }
        </div>
        }

        @if (variables && variables.stats) {
        <mat-list-item routerLink="/stats" class="sidenav-menu-list-item">
          <div class="item-container">
            <mat-icon svgIcon="Chart-Bar-Analytics" style="width:25px; height:25px;"></mat-icon>
            <h4 [routerLinkActive]="['is-active']" class="menu-item" mat-line>{{
              variables.stats }} </h4>
          </div>
        </mat-list-item>
        }

        <mat-list-item *hasPermission="Permission.TECHNOLOGY_MANAGE" (click)="actionDivManagement(openDivManagement)" class="sidenav-menu-list-item">
          <div class="item-container">
            <mat-icon svgIcon="Managment" class="management-icon" style="width:25px; height:25px;"></mat-icon>
            <h4 class="menu-item" mat-line>{{ variables.management }}
              @if (!openDivManagement) {
              <mat-icon class="trans-span" style="margin: 0;">arrow_drop_down</mat-icon>
              }
              @if (openDivManagement) {
              <mat-icon class="trans-span" style="margin: 0;">arrow_drop_up</mat-icon>
              }
            </h4>
          </div>
        </mat-list-item>
        @if (openDivManagement) {
        <div @slideToggle class="sidenav-item-list-wrapper">
          <mat-list-item *hasPermission="Permission.USER_MANAGE" style="width: 90%" routerLink="/users" class="sidenav-menu-list-item mat-list-new-div">
            <h4 [routerLinkActive]="['is-active']" mat-line>{{variables.users}}</h4>
          </mat-list-item>
          <mat-list-item *hasPermission="Permission.TECHNOLOGY_MANAGE" style="width: 90%" routerLink="/technologies" class="sidenav-menu-list-item mat-list-new-div">
            <h4 [routerLinkActive]="['is-active']" mat-line>
              {{variables.tecsAndTools}}</h4>
          </mat-list-item>
          <!-- Clients: SUPER-ADMIN only, per Sprint 04 spec. -->
          @if (authservice.isSuperAdmin() | async) {
          <mat-list-item style="width: 90%" routerLink="/tenants" class="sidenav-menu-list-item mat-list-new-div">
            <h4 [routerLinkActive]="['is-active']" mat-line>{{ variables.clients }}</h4>
          </mat-list-item>
          }
        </div>
        }

        <mat-list-item class="sidenav-menu-list-item"></mat-list-item>

      </mat-nav-list>
    </mat-drawer>
  </mat-drawer-container>
</div>